import { useT } from '../lib/i18n';
import { useFullscreen } from '../lib/useFullscreen';

interface Props {
  className?: string;
  fullscreenOnly?: boolean;
}

export function FullscreenToggle({ className, fullscreenOnly = false }: Props) {
  const t = useT();
  const { supported, isFullscreen, toggle } = useFullscreen();

  if (!supported) return null;
  if (fullscreenOnly && !isFullscreen) return null;

  const btnClass =
    className ??
    'btn-ghost px-3.5 py-2 text-[0.72rem] font-bold uppercase tracking-[0.12em] text-white/85';

  return (
    <button
      type="button"
      onClick={() => void toggle()}
      className={btnClass}
    >
      {isFullscreen ? t('common.fullscreenExit') : t('common.fullscreenEnter')}
    </button>
  );
}
